module.exports = __webpack_public_path__ + "img/imgs3.58d74f8b.png";